<div class="container">
  <div class="header">
    <div class="title">
      <span>{{ "mail.sendEmail" | translate }}</span>
    </div>
    <div class="icon-exit">
      <img
        class="close"
        src="{{ RESOURCE_SERVER_URL }}/assets/images/Close.svg" alt="Close Icon"
        (click)="onClose()"
      />
    </div>
  </div>
  <div class="body">
    <div class="row justify-content-center mt-3">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3">
        <label class="mailFontSize">{{ "mail.emailTo" | translate }}</label>
        <!-- for add mail -->
        <mat-chip-list
          class="noborder"
          class="example-chip-list"
          #chipList
          aria-label="Email selection"
        >
          <mat-chip
            *ngFor="let item of mailData"
            [selectable]="selectable"
            class="noborder"
            [removable]="removable"
            (removed)="removeToMail(item)"
          >
            {{ item }}
            <div class="cancel-button">
              <mat-icon matChipRemove *ngIf="removable">X</mat-icon>
            </div>
          </mat-chip>
          <input
            class="noborder"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addToMail($event)"
            [value]="myEmail"
          />
        </mat-chip-list>
      </div>
    </div>
    <hr class="line" />
    <div class="row justify-content-center mt-1">
      <custom-input-text
        label="{{ 'mail.subject' | translate }}"
        (valueChange)="onChangeValue($event, 'subject')"
      ></custom-input-text>
    </div>
    <div class="row justify-content-center mb-3 mt-1">
      <dxc-textarea
        label="{{ 'mail.message' | translate }}"
        (onChange)="onChangeValue($event, 'body')"
      ></dxc-textarea>
    </div>
  </div>

  <div class="row justify-content-center mt-3 mb-4">
      <custom-button
        label="{{ 'mail.send' | translate }}"
        mode="primary"
        margin="xsmall"
        (onClick)="onSend()"
      ></custom-button>
      <custom-button
        label="{{ 'mail.cancel' | translate }}"
        mode="secondary"
        margin="xsmall"
        (onClick)="onCancel()"
      ></custom-button>
  </div>
</div>
